import { ref } from 'vue';

import { cloneDeep, isEqual } from 'lodash';
import { defineStore } from 'pinia';

import { getLanguages } from '@/static/languages';
import { TypeCall } from '@/types/common';
import { InterpretationLanguage } from '@/types/components';
import {
  DUMMY_INTERPRETATION_LANGUAGES,
  INITIAL_INTERPRETATION_LANGUAGES,
  INPUT_LANGAUGE,
} from '@/utils/constants/language';

export const useLanguageStore = defineStore('language', () => {
  const interpretationLanguageOptions = ref<InterpretationLanguage>(cloneDeep(INITIAL_INTERPRETATION_LANGUAGES));

  const fetchInterpretationLanguage = () => {
    if (!isEqual(interpretationLanguageOptions.value, INITIAL_INTERPRETATION_LANGUAGES)) {
      return;
    }

    try {
      // TODO: api/chat/business/call/language/option로 받을 예정
      const res = DUMMY_INTERPRETATION_LANGUAGES;
      interpretationLanguageOptions.value = {
        inputEnabled: getLanguages(res.inputEnabled),
        textOutputEnabled: getLanguages(res.textOutputEnabled),
        voiceOutputEnabled: getLanguages(res.voiceOutputEnabled),
      };
    } catch {
      interpretationLanguageOptions.value = cloneDeep(INITIAL_INTERPRETATION_LANGUAGES);
    }
  };

  const getInterpretationLanguageOptions = (chatType: TypeCall) => {
    return INPUT_LANGAUGE.includes(chatType)
      ? interpretationLanguageOptions.value.inputEnabled
      : interpretationLanguageOptions.value.textOutputEnabled;
  };

  return {
    interpretationLanguageOptions,
    getInterpretationLanguageOptions,
    fetchInterpretationLanguage,
  };
});
